/*
  Tymzo Motion Engine V22
*/

(() => {
  "use strict";

  function reveal() {
    const elements = document.querySelectorAll(
      ".tymzo-product-upsell, .tymzo-product-bundle, .tymzo-product-benefits, .tymzo-product-faq, .tymzo-recently-viewed"
    );

    if (!("IntersectionObserver" in window)) {
      elements.forEach((el) => {
        el.style.opacity = 1;
        el.style.transform = "none";
      });
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.15,
      }
    );

    elements.forEach((el) => {
      el.setAttribute("data-tymzo-reveal", "");
      observer.observe(el);
    });
  }

  function rippleButtons() {
    document.addEventListener("pointerdown", function (e) {
      const button = e.target.closest("button,.button");

      if (!button) return;

      const rect = button.getBoundingClientRect();

      const ripple = document.createElement("span");
      ripple.className = "tymzo-ripple";

      ripple.style.left = e.clientX - rect.left + "px";
      ripple.style.top = e.clientY - rect.top + "px";

      button.appendChild(ripple);

      setTimeout(() => ripple.remove(), 700);
    });
  }

  function init() {
    reveal();
    rippleButtons();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();